export const URI_PERMISSIONS = 'organization/permissions';
export const URI_PERMISSIONS_BITMAP = `${URI_PERMISSIONS}/bitmap`;
export const URI_PERMISSIONS_TEAM = `${URI_PERMISSIONS}/team`;
export const URI_PERMISSIONS_LEGAL_ENTITY = `${URI_PERMISSIONS}/legal-entity`;
